import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { addToModifiedParams } from "../../catalog-editing-page-actions";
import { getEditObjData } from "../../catalog-editing-page-selectors";
import { WeedEditForm } from "./weed-edit-form";
import {
  getUniqBioClass,
  getUniqBioGroup,
  getUniqFamily,
  getUniqGenus,
} from "./weed-edit-form-selectors";

const mapStateToProps = createStructuredSelector({
  editObjData: getEditObjData,
  uniqFamily: getUniqFamily,
  uniqGenus: getUniqGenus,
  uniqBioClass: getUniqBioClass,
  uniqBioGroup: getUniqBioGroup,
});

const mapDispatchToProps = {
  addToModifiedParams,
};

export const WeedEditFormController = connect(
  mapStateToProps,
  mapDispatchToProps
)(WeedEditForm);
